<template>
  <!-- オーダー選択 -->
  <div id="CpapOrderSelectModal" style="width: 95%;height:95%;margin-left: 2%;margin-top: 1%;">
    <div class="modal-card" style="width: 100%;height:100%;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>オーダーID</th><td><input type="text" v-model="orderId"/></td>
              <th>営業所</th>
              <td>
                <select v-model="salesOfficeCode">
                  <option value=""></option>
                  <option v-for="item in branchOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </td>
              <th>担当営業</th><td><input type="text" v-model="salespersonCode"/></td>
            </tr>
            <tr>
              <th>品目コード</th><td><input type="text" v-model="itemCode"/></td>
              <th>シリアル</th><td><input type="text" v-model="serial"/></td>
              <th>医療機関<br>コード</th><td><input type="text" v-model="hospitalCode"/></td>
            </tr>
            <tr>
              <th>請求先コード</th><td><input type="text" v-model="billingDestinationCode"/></td>
              <th>オーダー形態</th>
              <td>
                <select id="orderType" class="2" name="オーダー形態" validate="required" :disabled="true" v-model="orderType">
                  <option v-for="order in this.orderProcessType" :value="order.value" :key="order.value">{{ order.label }}</option>
                </select>
              </td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length>0"
            id="quotationSelectTable"
            :data="data"
            paginated
            detailed
            :opened-detailed="detailOpenList"
            :has-detailed-visible="returnFalse"
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            v-bind:key="renderKey"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="10" centered>
                <b-radio class="customRadio" v-model="selectedItem" :native-value="props.row" @input="selecteRadio(props.row)"></b-radio>
              </b-table-column>
              <b-table-column field="orderId" label="オーダーID" width="350" sortable>{{props.row.orderId}}</b-table-column>
              <b-table-column field="billingDestinationCode" label="請求先コード" width="200" sortable>{{props.row.billingDestinationCode}}</b-table-column>
              <b-table-column field="billingDestinationName" label="請求先名" width="700" sortable>{{props.row.billingDestinationName}}</b-table-column>
              <b-table-column field="hospitalCode" label="医療機関コード" width="200" sortable>{{props.row.hospitalCode}}</b-table-column>
              <b-table-column field="hospitalName" label="医療機関名" width="700" sortable>{{props.row.hospitalName}}</b-table-column>
              <b-table-column field="items" label="品目コード / シリアル" width="700" sortable><span style="white-space: pre-wrap">{{getCpapCodeAndSerialStr(props.row.items)}}</span></b-table-column>
              <b-table-column field="salesOfficeName" label="営業所名" width="500" sortable>{{props.row.salesOfficeName}}</b-table-column>
              <b-table-column field="salespersonCode" label="営業員コード" width="200" sortable>{{props.row.salespersonCode}}</b-table-column>
              <b-table-column field="salespersonName" label="営業員名" width="500" sortable>{{props.row.salespersonName}}</b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <!-- トグル下の詳細 -->
              <span v-for="(item,index) in props.row.items" v-bind:key="index">
                <div class="content">
                  <table style="table-layout: fixed;">
                    <tr v-if="index==0">
                      <th style="width:25px;"/>
                      <td style="width:150px;">オーダー明細番号</td>
                      <td style="width:100px;">標準品目コード</td>
                      <td style="width:150px;">品目コード</td>
                      <td style="width:250px;">品目名</td>
                      <td style="width:250px;">シリアル</td>
                      <td style="width:250px;">患者名</td>
                      <td style="width:100px;">見積番号</td>
                      <td style="width:200px;">見積明細番号</td>
                    </tr>
                    <tr>
                      <th style="width:25px;">
                        <b-radio class="customRadio" v-model="selectedItemDetail" :native-value="item.itemCode+','+item.serial"/>
                      </th>
                      <td style="width:150px;">{{item.orderDetailsNumber}}</td>
                      <td style="width:100px;">{{item.standardItemCode}}</td>
                      <td style="width:150px;">{{item.itemCode}}</td>
                      <td style="width:250px;">{{item.itemName}}</td>
                      <td style="width:250px;">{{item.serial}}</td>
                      <td style="width:250px;">{{item.patientName}}</td>
                      <td style="width:100px;">{{item.quotationNumber}}</td>
                      <td style="width:200px;">{{item.quotationDetailsNumber}}</td>
                    </tr>
                  </table>
                </div>
              </span>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItemDetail.length >0">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
import cpapChoicesType from "@/components/mock/base/const.js";
export default {
  name: "CpapOrderSelectModal",
  props: {
    title:{default:"オーダー情報選択"},
    id: {default: ""},
    salesOffice: {default: ""},
    salesperson: {default: ""},
    billingDestination: {default: ""},
    hospital: {default: ""},
    order: {default: ""},
    item: {default: ""},
    serialNumber: {default: ""},
    orderTypeList: {default: []},
    model: {default: ""}, // QA301 検索結果にディスコン品を表示させるか判定するため処方機種の品目コードをモーダル内で受け取る
  },
  methods: {
    returnFalse: function() {
      return false
    },
    selecteRadio: function(rowData) {
      this.detailOpenList = [rowData]
      this.selectedItemDetail = [];
    },
    save: function() {
      var rtnObj = {}
      var list = this.selectedItemDetail.split(',')
      var selectedItemCode = ""
      var selectedSerial = ""
      if(list && list.length > 1){
        selectedItemCode = list[0]
        selectedSerial = list[1]
      }
      // 品目コードでitems内を絞る
      if(selectedItemCode && (selectedItemCode != "undefined")){
        this.selectedItem.items = this.selectedItem.items.filter(val => val.itemCode == selectedItemCode)
      }
      // 品目シリアルでitems内を絞る
      if(selectedSerial && (selectedSerial != "undefined")){
        this.selectedItem.items = this.selectedItem.items.filter(val => val.serial == selectedSerial)
      } 
      // 絞ったitemsが2つ以上ある場合
      if(this.selectedItem.items.length > 1){
        this.selectedItem.items = []
      }
      rtnObj = JSON.parse(JSON.stringify(this.selectedItem));
      this.$emit('select', rtnObj);
      this.$parent.close();
    },
    doSearch: function() {
      if(!this.orderId && !this.salesOfficeCode && !this.salespersonCode && !this.billingDestinationCode && 
            !this.hospitalCode && !this.itemCode && !this.serial && !this.patientCode){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.selectedItem = '';
      this.selectedItemDetail = [];
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getCpapOrderPOST({
            body:{
              orderId:_this.orderId ? _this.orderId : "",
              salesOfficeCode:_this.salesOfficeCode ? "J"+_this.salesOfficeCode : "",
              salespersonCode:_this.salespersonCode ? _this.salespersonCode : "",
              billingDestinationCode:_this.billingDestinationCode ? _this.billingDestinationCode : "",
              hospitalCode:_this.hospitalCode ? _this.hospitalCode : "",
              orderType:_this.orderType ? _this.orderType : "",
              itemCode:_this.itemCode ? _this.itemCode : "",
              serial:_this.serial ? _this.serial : "",
              model:_this.model ? _this.model : "", // QA301 検索結果にディスコン品を表示させるか判定するため処方機種の品目コードを検索処理に渡す
            }
          });
        },
        async function(result){
          if(result.obj.length < 1){
            _this.showMessage('該当するオーダー情報は存在しません。');
          }
          _this.data = result.obj;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    },
    getCpapCodeAndSerialStr: function(items) {
      let cpapCodeAndSerialStr = ""
      for(let item of items){
        let itemCode = item.itemCode;
        if(this.cpapCodeList.includes(itemCode)){
          //取得した品目コードがCPAP機器の品目コードの場合、”品目コード/シリアル”を表示する
          if(cpapCodeAndSerialStr != ""){
            cpapCodeAndSerialStr += '\n'
          }
          cpapCodeAndSerialStr = cpapCodeAndSerialStr + itemCode + " / " + item.serial
        }
      }
      return cpapCodeAndSerialStr;
    },
    getCpapChoicesList: async function() {
      this.orderProcessType = this.getCpapChoiceList(cpapChoicesType.orderProcessType,false);
    },
  },
  data() {
    let modelList = this.getCpapMaster();
    let cpapCodeList = [];
    for(let cpapCode of modelList){
      cpapCodeList.push(cpapCode.itemCode);
    }
    var cpapCodeMaster = this.getCpapCodeMaster();
    // let branchOfficeMaster = this.getBranchOfficeMaster();
    let branchOfficeMaster= this.getSalesOfficeMaster();
    return {
      orderId: this.id,
      salesOfficeCode: this.salesOffice,
      salespersonCode: this.salesperson,
      billingDestinationCode: '',
      hospitalCode:this.hospital,
      orderType:"O7",
      itemCode:this.item,
      serial:this.serialNumber,
      orderProcessType:this.orderTypeList,
      branchOfficeMaster,
      data: [],
      selectedItem: '',
      selectedItemDetail: [],
      detailOpenList:[],
      targetNumber:"",
      targetDetailsNumber:"",
      targetIndex:"",
      renderKey:true,
      cpapCodeMaster,
      cpapCodeList
    };
  },
  filters: {},
  components: {},
  async mounted() {
    if(!this.orderProcessType || this.orderProcessType.length==0){
      // CPAP選択肢リスト取得
      this.getCpapChoicesList();
    }
  }
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/CpapOrderSelectModal.vue